import { __assign, __read, __rest, __spread } from "tslib";
import React from 'react';
import { sortByValue, legendRadius, verticalPositionScale, radiusScale, } from './bubble-legend.utils';
export var Labels = function (_a) {
    var domain = _a.domain, typography = _a.typography, minRadius = _a.minRadius, maxRadius = _a.maxRadius;
    var sortedDomain = sortByValue(domain);
    var maxRange = Math.max.apply(Math, __spread(legendRadius));
    var _b = __read(sortedDomain, 2), max = _b[1];
    var fontColor = typography.fontColor, textStyles = __rest(typography, ["fontColor"]);
    var verticalPosition = verticalPositionScale(maxRange);
    var legendValue = radiusScale(minRadius, maxRadius, max);
    return (React.createElement(React.Fragment, null, legendRadius.map(function (radius) {
        var x = maxRange;
        var y = (typography === null || typography === void 0 ? void 0 : typography.fontSize) ? maxRange * 2 - verticalPosition(radius) + (typography === null || typography === void 0 ? void 0 : typography.fontSize)
            : maxRange * 2 - verticalPosition(radius);
        return (React.createElement("text", { key: radius, x: x, y: y, dominantBaseline: "ideographic", textAnchor: "middle", fill: fontColor, style: __assign({}, textStyles) }, Math.floor(legendValue(radius))));
    })));
};
export default Labels;
